import { isAuthGuardActive } from '../constants/config';
import { setCurrentUser, getCurrentUser } from '.';
import {
  fetchPolicyAgreementStatus,
  isPolicyExemptPath,
  isSessionPolicyAgreed,
  markSessionPolicyAgreed,
  needsPolicyAgreement,
  POLICY_GATE_PATH
} from './policyAgreement';

const redirectDashboardByPlanType = (to, next) => {
  const pt = localStorage.getItem('pt');
  const isOviDashboard = to.path === '/dashboard' || to.path.startsWith('/dashboard/');
  const isEcpDashboard = to.path === '/dashboardecp' || to.path.startsWith('/dashboardecp/');

  if (isOviDashboard) {
    if (pt === 'ecp' || pt === 'edp' || pt === 'iglow') {
      next('/dashboardecp/reminderspage');
      return true;
    }
    if (pt === 'bibo') {
      next('/dashboardbibo');
      return true;
    }
    if (pt === 'pcp') {
      next('/dashboardpcp');
      return true;
    }
    if (pt === 'ecc') {
      next('/dashboardecc');
      return true;
    }
  }

  if (isEcpDashboard) {
    if (pt === 'ovi') {
      next('/dashboard/reminderspage');
      return true;
    }
    if (pt === 'bibo') {
      next('/dashboardbibo');
      return true;
    }
    if (pt === 'pcp') {
      next('/dashboardpcp');
      return true;
    }
    if (pt === 'ecc') {
      next('/dashboardecc');
      return true;
    }
  }

  return false;
};

const applyHostPlanType = () => {
  if (window.location.host === 'my.orbixvictus.com') {
    document.title = 'Orbix Victus International';
    document.querySelector("link[rel*='icon']").href = 'favicon.ico';
    localStorage.setItem('pt', 'ovi');
  }
  if (window.location.host === 'localhost:8081') {
    document.title = 'EC5 Dev';
    localStorage.setItem('pt', 'ovi');
  }
  if (window.location.host === 'dev-ecpv.empoweredconsumerism.com') {
    document.title = 'EC5 Dev';
    localStorage.setItem('pt', 'ecp');
  }
  if (window.location.host === 'ng.aimglobalinc.com') {
    document.title = 'Alliance in Motion Global Inc.';
    document.querySelector("link[rel*='icon']").href = 'ecicon.ico';
    localStorage.setItem('pt', 'edp');
  }
  if (window.location.host === 'dtc.aimglobalinc.com') {
    document.title = 'Alliance in Motion Global Inc.';
    document.querySelector("link[rel*='icon']").href = 'ecicon.ico';
    localStorage.setItem('pt', 'edp');
  }
  if (window.location.host === 'ec5.empoweredconsumerism.com') {
    document.title = 'Empowered Consumerism';
    localStorage.setItem('pt', 'ecp');
    document.querySelector("link[rel*='icon']").href = 'ecicon.ico';
  }
  if (window.location.host === 'ec5test.empoweredconsumerism.com') {
    document.title = 'Empowered Consumerism';
    localStorage.setItem('pt', 'ecp');
    document.querySelector("link[rel*='icon']").href = 'ecicon.ico';
  }
  if (window.location.host === 'my.economydriver.com') {
    document.title = 'Economy Driver';
    document.querySelector("link[rel*='icon']").href = 'ecicon.ico';
    localStorage.setItem('pt', 'edp');
  }
  if (window.location.host === 'my.economydesigner3.com') {
    document.title = 'Economy Designer 3.0';
    document.querySelector("link[rel*='icon']").href = 'ecicon.ico';
    localStorage.setItem('pt', 'edp');
  }
  if (window.location.host === 'my.bibosuperapp.com') {
    document.title = 'BIBO';
    document.querySelector("link[rel*='icon']").href = 'BIBO_ICON.ico';
    localStorage.setItem('pt', 'bibo');
  }
  if (window.location.host === 'my.iglow247.com') {
    document.title = 'iGlow 247';
    document.querySelector("link[rel*='icon']").href = 'iglow_icon.ico';
    localStorage.setItem('pt', 'iglow');
  }
  if (window.location.host === 'my.ecrowdcommerce.com') {
    document.title = 'E-Crowd Commerce';
    document.querySelector("link[rel*='icon']").href = 'ECC_ICON.ico';
    localStorage.setItem('pt', 'ecc');
  }
  if (window.location.host === 'pcp.empoweredconsumerism.com') {
    document.title = 'PCP';
    document.querySelector("link[rel*='icon']").href = 'PCP_ICON.ico';
    localStorage.setItem('pt', 'pcp');
  }
};

const handleSignInRedirects = (to, next) => {
  if (to.path.indexOf('/sign-in') < 0) {
    return false;
  }

  if (localStorage.getItem('ecmtctoken') != null && localStorage.getItem('ecmtctoken') !== '') {
    if (localStorage.getItem('pt') === 'ecp' || localStorage.getItem('pt') === 'edp' || localStorage.getItem('pt') === 'iglow') {
      next('/dashboardecp/reminderspage');
    } else if (localStorage.getItem('pt') === 'ovi') {
      next('/dashboard/reminderspage');
    } else if (localStorage.getItem('pt') === 'ecc') {
      next('/dashboardecc');
    } else if (localStorage.getItem('pt') === 'pcp') {
      next('/dashboardpcp');
    } else {
      next('/dashboardbibo');
    }
    return true;
  }

  if (localStorage.getItem('pt') === 'ecp' && to.path.indexOf('/sign-in-ec') < 0) {
    next('/sign-in-ec');
    return true;
  }

  if (localStorage.getItem('pt') === 'edp' && to.path.indexOf('/sign-in-ed') < 0) {
    next('/sign-in-ed');
    return true;
  }

  if (localStorage.getItem('pt') === 'bibo' && to.path.indexOf('/sign-in-bibo') < 0) {
    next('/sign-in-bibo');
    return true;
  }

  if (localStorage.getItem('pt') === 'iglow' && to.path.indexOf('/sign-in-iglow') < 0) {
    next('/sign-in-iglow');
    return true;
  }

  if (localStorage.getItem('pt') === 'ecc' && to.path.indexOf('/sign-in-ecc') < 0) {
    next('/sign-in-ecc');
    return true;
  }

  if (localStorage.getItem('pt') === 'pcp' && to.path.indexOf('/sign-in-pcp') < 0) {
    next('/sign-in-pcp');
    return true;
  }

  if (localStorage.getItem('pt') === 'ovi' && (to.path.indexOf('/sign-in-ec') >= 0 || to.path.indexOf('/sign-in-ed') >= 0)) {
    next('/sign-in');
    return true;
  }

  return false;
};

const redirectUnauthenticated = (next) => {
  setCurrentUser(null);
  if (localStorage.getItem('pt') === 'ecp') {
    next('/sign-in-ec');
  } else if (localStorage.getItem('pt') === 'edp') {
    next('/sign-in-ed');
  } else if (localStorage.getItem('pt') === 'bibo') {
    next('/sign-in-bibo');
  } else if (localStorage.getItem('pt') === 'iglow') {
    next('/sign-in-iglow');
  } else if (localStorage.getItem('pt') === 'ecc') {
    next('/sign-in-ecc');
  } else if (localStorage.getItem('pt') === 'pcp') {
    next('/sign-in-pcp');
  } else {
    next('/sign-in');
  }
};

const ensurePolicyAgreement = async (to, next) => {
  if (isPolicyExemptPath(to.path)) {
    return true;
  }

  if (isSessionPolicyAgreed()) {
    return true;
  }

  try {
    const status = await fetchPolicyAgreementStatus();
    if (needsPolicyAgreement(status)) {
      next({ path: POLICY_GATE_PATH, query: { redirect: to.fullPath } });
      return false;
    }
    markSessionPolicyAgreed();
    return true;
  } catch {
    // 502 / expired JWT / network errors are not "unsigned T&C".
    // Token refresh and logout are already handled by the request interceptor.
    return true;
  }
};

export default async (to, from, next) => {
  applyHostPlanType();

  if (handleSignInRedirects(to, next)) {
    return;
  }

  if (to.matched.some((record) => record.meta.loginRequired)) {
    if (isAuthGuardActive) {
      const user = getCurrentUser();

      if (user && localStorage.getItem('ecmtctoken') != null) {
        const roleArrayHierarchic = to.matched.filter((x) => x.meta.roles).map((x) => x.meta.roles);
        if (roleArrayHierarchic.every((x) => x.includes(user.role))) {
          if (redirectDashboardByPlanType(to, next)) {
            return;
          }
          const policyAllowed = await ensurePolicyAgreement(to, next);
          if (!policyAllowed) {
            return;
          }
          next();
        } else {
          next('/404');
        }
      } else {
        redirectUnauthenticated(next);
      }
    } else {
      next();
    }
  } else {
    next();
  }
};
